import React, { useEffect, useState } from 'react';

// Local Resources
import { STATE_COLOR, AnalysisResultToStateColor, ANALYSIS_RESULT } from '../enums';

// MaterialUI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import InputIcon from '@mui/icons-material/Input';

// Tippy.JS Resources
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/shift-away.css';

// Default image size parameters
const defaultWidth = 64;
const defaultHeight = 70;

function BuildPopover(auxState) {
	if (auxState && auxState.length > 0) {

		return (
			<span
				style={{
					fontFamily: 'Saira, sans-serif',
					fontWeight: '600'
				}}
			>
				<p><b>Aux Inputs</b></p>
				<br />
				{auxState.map((auxAlarm) => {
					return <span style={{ color: STATE_COLOR.WITHIN_LIMITS }}>{auxAlarm}<br /></span>;
				})}
			</span>
		);

	} else {

		return (
			<span
				style={{
					fontFamily: 'Saira, sans-serif',
					fontWeight: '600'
				}}
			>
				<p><b>Aux Inputs</b></p>
				<p style={{ color: STATE_COLOR.UNKNOWN }}>No Aux Alarm Data</p>
			</span>
		);
	}
}

export default function AuxIcon(props) {

	const {auxState, scale = 1.0} = props;

	const state = AnalysisResultToStateColor(ANALYSIS_RESULT.ANALYSIS_WITHIN_LIMITS);

	const popover = BuildPopover(auxState)

	return (
		<Tippy
			content={popover}
			placement="bottom"
			animation="shift-away"
		>
			<Box
				border='solid'
				borderRadius={0.75}
				borderColor='#FFFFFF11'
				bgcolor='#FFFFFF22'
				padding='3px'
				margin='4px'
				sx={{
					borderWidth: '1px',
					'&:hover': {
						color: '#FFFFFF',
						backgroundColor: '#FFFFFF44',
					},
				}}
			>
				<InputIcon
					fontSize='large'
					sx={{
						marginX: '6px',
						color: `${state}`,
						width: `${defaultWidth * scale}px`,
						height: `${defaultHeight * scale}px`,
					}}
				/>
				<Typography
					fontFamily='Helvetica Neue LT Std Roman, sans-serif'
					color='#FFFFFF'
					align='center'
				>
					Aux Inputs
				</Typography>
			</Box>
		</Tippy>
	);
}